import React from 'react';
import { Wand2, Layout, Eye, FileDown } from 'lucide-react';

const features = [
  {
    icon: <Wand2 className="w-6 h-6" />,
    title: 'AI-Driven Customization',
    description: 'Smart suggestions and auto-formatting powered by advanced AI'
  },
  {
    icon: <Layout className="w-6 h-6" />,
    title: 'Professional Templates',
    description: 'Choose from dozens of ATS-friendly, modern templates'
  },
  {
    icon: <Eye className="w-6 h-6" />,
    title: 'Real-Time Preview',
    description: 'See changes instantly as you type and edit'
  },
  {
    icon: <FileDown className="w-6 h-6" />,
    title: 'Easy PDF Export',
    description: 'Download your resume in perfect PDF format with one click'
  }
];

export default function Features() {
  return (
    <section id="features" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Powerful Features for Perfect Resumes
        </h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="p-6 rounded-xl bg-white border border-gray-100 
              shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center 
                justify-center text-indigo-600 mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}